import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { DLOPercentageOfWeeklyDSDVolumeTable } from '../../../components/Tables';
import DSDVolumeZoneDistributionByDay from '../../../components/Tables/DSDVolumeZoneDistributionByDay';
import { transformDailyPercentageData } from '../utils/dataTransformers';

interface DSDVolumeTablesProps {
  dloLocationSetting: any;
  styles: any;
}

const DSDVolumeTables: React.FC<DSDVolumeTablesProps> = ({
  dloLocationSetting,
  styles
}) => {
  return (
    <>
      {/* DLOPercentageOfWeeklyDSDVolumeTable - DSD */}
      {dloLocationSetting.dsdDailyLoading ? (
        <View style={styles.tableLoaderContainer}>
          <Text style={styles.tableLoadingText}>Loading DSD Volume Percentage...</Text>
        </View>
      ) : (
        <DLOPercentageOfWeeklyDSDVolumeTable
          data={transformDailyPercentageData(dloLocationSetting.DSDDailyPercentage?.data || [])}
          onSave={() => console.log('Percentage table save action')}
          onRowSave={(rowId) => console.log('Percentage row save action:', rowId)}
          headerTitle="PERCENTAGE OF WEEKLY DSD VOLUME"
          type="DSD"
          context="location-settings"
          style={styles.percentageTable}
        />
      )}

      {/* DSDVolumeZoneDistributionByDay */}
      {dloLocationSetting.dsdLoading ? (
        <View style={styles.tableLoaderContainer}>
          <Text style={styles.tableLoadingText}>Loading Percentage of Weekly DSD Voume...</Text>
        </View>
      ) : (
        <DSDVolumeZoneDistributionByDay
          data={dloLocationSetting.DSDVolumeDistributionByDay?.data || []}
          onAddZone={() => console.log('Add zone action')}
          onSave={() => console.log('DSD Zone Volume table save action')}
          title="DSD ZONE VOLUME DISTRIBUTION BY DAY"
          type="DSD"
          context="location-settings"
          style={styles.zoneDistributionTable}
        />
      )}
    </>
  );
};

export default DSDVolumeTables;
